/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

import PropTypes from 'prop-types';
import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { Modal } from 'foundations-components/transitional/components/Modal';
import ModalTypesConstants from '../../constants/ModalTypesConstants';
import * as ModalConstants from '../../constants/ModalConstants';
import { H2 } from 'foundations-components/transitional/components/H2';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const I18N_PREFIX = 'knowledgeContentUI.importArticles.modals.cancel';
class ConfirmCancelImportArticlesModal extends Component {
  constructor(...args) {
    super(...args);
    this.onCancelImportArticles = () => {
      this.props.onCancelImportArticles().then(this.props.onClose);
    };
  }
  render() {
    const {
      isRequesting,
      onClose
    } = this.props;
    return /*#__PURE__*/_jsxs(Modal, {
      size: "auto"
      // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
      ,
      use: ModalTypesConstants.DANGER,
      width: ModalConstants.MODAL_WIDTH,
      children: [/*#__PURE__*/_jsxs(DialogHeader, {
        children: [/*#__PURE__*/_jsx(DialogCloseButton, {
          onClick: onClose
        }), /*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `${I18N_PREFIX}.header`
          })
        })]
      }), /*#__PURE__*/_jsx(DialogBody, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${I18N_PREFIX}.message`
        })
      }), /*#__PURE__*/_jsxs(DialogFooter, {
        children: [/*#__PURE__*/_jsx(Button, {
          onClick: this.onCancelImportArticles,
          use: "danger",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `${I18N_PREFIX}.buttons.cancel`
          })
        }), /*#__PURE__*/_jsx(Button, {
          disabled: isRequesting,
          onClick: onClose,
          use: "tertiary-light",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `${I18N_PREFIX}.buttons.continue`
          })
        })]
      })]
    });
  }
}
ConfirmCancelImportArticlesModal.propTypes = {
  isRequesting: PropTypes.bool.isRequired,
  onCancelImportArticles: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};
export default ConfirmCancelImportArticlesModal;